<template>
  <v-container fluid>
    <div class="form-inputs">
      <v-alert v-for="(item, index) in mxStoreUserErrors" :key="index" dense type="error" outlined text
               dismissible transition="slide-x-transition" class="py-0 text-uppercase my-0">
        {{ item[0] }}
      </v-alert>
      <v-autocomplete v-model="storeId" outlined label="Branch" :items="stores" item-value="id" hide-details="auto"
                      item-text="name" />
      <v-autocomplete v-model="homepage" outlined hide-details="auto" item-value="routeName" item-text="alias"
                      :items="getHomepageList()" label="Homepage" />
      <v-text-field v-model="username" outlined hide-details="auto" label="Username" />
      <v-text-field v-model="name" outlined hide-details="auto" label="Name" />
      <!-- <v-autocomplete label="Role" hide-details="auto" :items="userRoles" v-model="role"></v-autocomplete> -->
      <v-autocomplete v-model="roleId" outlined label="Role" hide-details="auto" :items="userRoles" />
      <v-text-field v-model="password" outlined hide-details="auto" label="Password" type="password" />
      <v-text-field v-model="confirmPassword" outlined hide-details="auto" label="Confirm Password"
                    type="password" />
      <v-text-field v-model="email" outlined hide-details="auto" label="Email" />
      <div style="height: 44px;display: flex;align-items: center;">
        <v-switch v-model="active" style="margin-top:0px;" hide-details="auto" label="Active" />
      </div>
      <v-btn dark color="primary" :loading="mxStoringUser" @click="initStore">
        Save
      </v-btn>
    </div>
  </v-container>
</template>
<style scoped lang="scss">
.form-inputs {
  display: grid;
  gap: 10px;
}
</style>
<script>
import axiosExtra from '../../../../../../extra-functions/axios.extra'
import { routeNames } from '../../../../../../router'
import { storeUser } from './../../../../mixins/users.mixin'
import { mapState } from 'vuex'

export default {
  name: 'VCreateUser',
  data() {
    return {
      gettingUserRole: false,
      userRoles: [],
      username: null,
      name: null,
      email: null,
      active: 0,
      storeId: null,
      role: null,
      roleId: null,
      password: null,
      confirmPassword: null,
      homepage: null,
    }
  },
  created() {
    // this.getUserRoles()
    this.getUserRolesV2()
  },
  computed: {
    ...mapState({
      stores: state => state.branchLocation.list,
      token: state => state.auth.token,
    }),
  },
  methods: {
    initStore() {
      this.mxStoreUser({
        username: this.username,
        name: this.name,
        email: this.email,
        store_id: this.storeId,
        // role: this.role,
        homepage: this.homepage,
        role: 'admin',
        role_id: this.roleId,
        password: this.password,
        password_confirmation: this.confirmPassword,
        active: this.active,
      }, () => {
        this.$emit('close-dialog')
      })
    },
    async getUserRolesV2(retries = 0) {
      try {
        const axios = axiosExtra(this.token)
        if (retries > 5) return
        this.gettingUserRole = true
        const { data } = await axios.get('/roles')
        this.userRoles = data ?? []
      } catch (e) {
        setTimeout(() => this.getUserRoles(retries + 1), 3000)
      } finally {
        this.gettingUserRole = false
      }
    },
    getHomepageList() {
      return routeNames
    },
    // async getUserRoles(retries = 0) {
    //   try {
    //     if (retries > 5) return
    //     this.gettingUserRole = true
    //     const { data } = await axiosExtra(this.token).get('/admin/users/roles')
    //     this.userRoles = data ?? []
    //   } catch (e) {
    //     setTimeout(() => this.getUserRoles(retries + 1), 3000)
    //   } finally {
    //     this.gettingUserRole = false
    //   }
    // },
  },
  mixins: [
    storeUser,
  ],
}
</script>
